export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            关于51吃瓜
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            专注热门人物吃瓜，做最专业的八卦资讯平台
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-6 md:p-8">
            <div className="flex flex-col md:flex-row gap-8 items-start">
              <div className="flex-shrink-0">
                <div className="w-20 h-20 rounded-2xl bg-primary-500 flex items-center justify-center">
                  <span className="w-10 h-10 flex items-center justify-center">
                    <i className="ri-chat-smile-2-fill text-3xl text-white"></i>
                  </span>
                </div>
              </div>
              <div className="flex-1">
                <h3 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                  百万吃瓜群众的首选平台
                </h3>
                <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  <p>
                    51吃瓜app成立于2024年，是国内领先的热门人物吃瓜内容聚合平台。
                    我们聚焦台北娜娜、莫里秀、玩偶姐姐等一线热门人物，为吃瓜群众提供最新、最全、最快的八卦资讯和独家爆料。
                  </p>
                  <p>
                    平台每日更新超过120条精品内容，涵盖视频合集、深度分析、时间线梳理、网友热评等多种形式。
                    我们拥有一支专业的吃瓜内容团队，7×24小时追踪全网热点，确保每一位吃瓜群众都能第一时间获取最新消息。
                  </p>
                  <p>
                    在51吃瓜app，你不仅能看瓜，还能和200万+吃瓜群众一起讨论、分享、互动。
                    无论是台北娜娜的视频追踪、莫里秀的全系列合集，还是玩偶姐姐的最新动态，这里都有最全面的整理和最独到的解读。
                  </p>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-6 pt-6 border-t border-background-200/60">
                  {[
                    { num: '200万+', label: '活跃用户' },
                    { num: '8600+', label: '独家爆料' },
                    { num: '99.9%', label: '内容覆盖率' },
                    { num: '24h', label: '全天候更新' },
                  ].map((stat) => (
                    <div key={stat.label} className="text-center">
                      <div className="text-lg font-bold text-primary-500">{stat.num}</div>
                      <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}